import styled from 'styled-components';

export const SelectedBlurFilter = () => {
    return <Overlay></Overlay>;
};

const Overlay = styled.div`
    position: absolute;
    top: -1px;
    left: -1px;
    right: -1px;
    bottom: -1px;
    background-color: rgba(70, 70, 70, 0.6);
    backdrop-filter: blur(5px);
    border-radius: 7px;
    border: 2px solid #e25000;
`;
